import { render, staticRenderFns } from "./Temoignage.vue?vue&type=template&id=c5f482f6&"
import script from "./Temoignage.vue?vue&type=script&lang=js&"
export * from "./Temoignage.vue?vue&type=script&lang=js&"
import style0 from "./Temoignage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports